export const downloadXLSX = async (data: any, filename = "file.xlsx") => {
  const csvData = new Blob([data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  const csvURL = URL.createObjectURL(csvData);
  const link = document.createElement("a");
  link.href = csvURL;
  link.download = `${filename}`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const downloadCSV = (data: any, fileName = "excel", includeBOM = false) => {
  const BOM = "\uFEFF";
  const csvData = new Blob([includeBOM ? BOM : "", data], {
    type: "text/csv;charset=utf-8;",
  });
  const csvURL = URL.createObjectURL(csvData);
  const link = document.createElement("a");
  link.href = csvURL;
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default downloadCSV;
